import { getDataLayer } from 'utils';

const useGTM = () => {
    let pushToGTM = () => {};
    const dataLayer = getDataLayer();
    if (dataLayer) {
        pushToGTM = data => dataLayer.push(data);
    }

    return [dataLayer, pushToGTM];
};

export default useGTM;
